export const SIZE_OPTIONS = ["XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL", "Standart"];

export const COLOR_OPTIONS = [
  { name: "Lacivert", hex: "#1E293B" },
  { name: "Siyah", hex: "#0B0B0B" },
  { name: "Gri", hex: "#6B7280" },
  { name: "Beyaz", hex: "#F5F5F5" },
  { name: "Kırmızı", hex: "#DC2626" },
  { name: "Turuncu", hex: "#EA580C" },
  { name: "Sarı", hex: "#FACC15" },
  { name: "Haki", hex: "#4D5D3A" },
  { name: "Yeşil", hex: "#16A34A" },
  { name: "Mavi", hex: "#2563EB" },
  { name: "Kahverengi", hex: "#78350F" },
];

export const FEATURE_OPTIONS = [
  "Su Geçirmez", "Rüzgar Geçirmez", "Nefes Alabilir", "Yanmaz", "Reflektörlü",
  "Antistatik", "Kaynağa Dayanıklı", "İçi Polarlı", "Çelik Burun", "Yüksek Görünürlük",
  "Anti-Pilling", "Baskıya Uygun", "Isı Yalıtımlı", "Kışlık", "Çok Cepli", "Form Korur", "Dayanıklı",
];
